import map from 'lodash/map';

import React from 'react';
import PropTypes from 'prop-types';

import SelectedColumn from './SelectedColumn';

const SelectedColumnListComponent = props => (
  <div>
    <div className="left-pfane">
      <div>
        <h2 className="header-page">Numerical Statistics</h2>
        {map(props.selectedStats, parameter => (
          parameter.targetType === 'numerical' && <SelectedColumn key={parameter.name} {...parameter} />
        ))}
      </div>
    </div>
    <div>
      <div>
        <p className="font-700 pt-20 sidebar-component-padding">Categorical Statistics</p>
        {map(props.selectedStats, parameter => (
          parameter.targetType === 'categorical' && <SelectedColumn key={parameter.name} {...parameter} />
        ))}
      </div>
    </div>
  </div>
);

SelectedColumnListComponent.propTypes = {
  selectedStats: PropTypes.object.isRequired
};

export default SelectedColumnListComponent;
